import L from "leaflet";
import "leaflet/dist/leaflet.css";

export const MEMBER_COLORS = ["#0084ff", "#00e676", "#a970ff", "#ff9100", "#ff3b30", "#ffea00"];

export function createMap(el, center = [55.751, 37.618], zoom = 12) {
  const map = L.map(el, { zoomControl: true, attributionControl: false }).setView(center, zoom);
  const layers = {
    "Детальная": L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 20, maxNativeZoom: 19 }),
    "Схема": L.tileLayer("https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png", {
      maxZoom: 20, subdomains: "abcd", detectRetina: false }),
    "Тёмная": L.tileLayer("https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png", {
      maxZoom: 20, subdomains: "abcd" }),
    "Спутник": L.tileLayer("https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}", {
      maxZoom: 19 }),
  };
  const saved = localStorage.getItem("lifeos-map-layer");
  (layers[saved] || layers["Детальная"]).addTo(map);
  L.control.layers(layers, null, { position: "topright" }).addTo(map);
  map.on("baselayerchange", (e) => localStorage.setItem("lifeos-map-layer", e.name));
  L.control.attribution({ prefix: false }).addAttribution("© OpenStreetMap · CARTO · Esri").addTo(map);
  return map;
}

export function memberIcon(name, color) {
  return L.divIcon({
    className: "",
    html: `<div style="width:34px;height:34px;border-radius:50%;background:${color};border:2.5px solid rgba(255,255,255,0.9);
      display:flex;align-items:center;justify-content:center;color:#fff;font-weight:800;font-size:14px;
      box-shadow:0 2px 10px rgba(0,0,0,0.5)">${(name || "?")[0].toUpperCase()}</div>`,
    iconSize: [34, 34],
    iconAnchor: [17, 17],
  });
}

export const haversine = (a, b) => {
  const R = 6371000, dLat = ((b.lat - a.lat) * Math.PI) / 180, dLng = ((b.lng - a.lng) * Math.PI) / 180;
  const s = Math.sin(dLat / 2) ** 2 + Math.cos((a.lat * Math.PI) / 180) * Math.cos((b.lat * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(s));
};

export const fmtDuration = (s) => {
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = Math.floor(s % 60);
  return h > 0 ? `${h}:${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}` : `${m}:${String(sec).padStart(2, "0")}`;
};

export const fmtAgo = (iso) => {
  const min = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (min < 1) return "только что";
  if (min < 60) return `${min} мин назад`;
  const h = Math.round(min / 60);
  if (h < 24) return `${h} ч назад`;
  return new Date(iso).toLocaleDateString("ru-RU", { day: "numeric", month: "short" });
};
